import { render } from "./MyAccountCardsPage.vue?vue&type=template&id=11c70b18&scoped=true"
import script from "./MyAccountCardsPage.vue?vue&type=script&lang=js"
export * from "./MyAccountCardsPage.vue?vue&type=script&lang=js"

import "./MyAccountCardsPage.vue?vue&type=style&index=0&id=11c70b18&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11c70b18"]])

export default __exports__